import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic'
import { style } from './ListRoutesPage.module.scss'

// Actions
import { TextField, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box, Chip } from "@material-ui/core";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable from "../../../components/table/Table";
import { getIcon } from "../../../icon/icon";
import { getRoutes, generateRoutes } from "../../../state/actions/RouteActions";
import PageContainer from "../../../components/page-container/PageContainer";
import Search from "../../../components/search/Search";
import { useTranslation } from "react-i18next";

function ListRoutesPage(props) {
  const routes = useSelector(state => state.RouteReducer.routes)
  const instanceId = useSelector(state => state.RouteReducer.instanceId)
  const statusOutput = useSelector(state => state.RouteReducer.statusOutput)

  const dispatch = useDispatch()
  const [t, i18n] = useTranslation()

  const [loading, setLoading] = useState(false)
  const [originalData, setOriginalData] = useState([])
  const [searchedData, setSearchedData] = useState([])
  const [generateRoutesModalOpen, setGenerateRoutesModalOpen] = useState(false)
  const [generatingRoutes, setGeneratingRoutes] = useState(false)
  const [syncFailed, setSyncFailed] = useState(false)

  useEffect(() => {
    setLoading(true)
    dispatch(getRoutes(() => {
      setLoading(false)
    }))
  }, [])

  useEffect(() => {

    const data = createData(routes);
    setOriginalData(data)
    setSearchedData(data)

  }, [routes])

  useEffect(() => {
    if (instanceId == null) {
      setGeneratingRoutes(false)
    } else {
      setGeneratingRoutes(true)
    }
  }, [instanceId])

  useEffect(() => {
    if (statusOutput == "Failed" || statusOutput == "Cancelled" || statusOutput == "Terminated") {
      setGeneratingRoutes(false)
      setSyncFailed(true)
    } else {
      setSyncFailed(false)
    }
  }, [statusOutput])

  function handleStartSync() {
    setGenerateRoutesModalOpen(false)
    dispatch(generateRoutes(!syncFailed ? instanceId : null, () => {
      setSyncFailed(false)
    }))
  }

  function createData(routes) {
    const routeKeys = Object.keys(routes)

    return routeKeys.map(routeKey => {
      const route = routes[routeKey]
      return { id: route.id }
    })
  }

  function handleSearch(results) {
    setSearchedData(results)
  }


  function createCells(headers) {
    let cells = []

    headers.forEach(header => {
      let cell = {}

      cell.id = header.id

      cell.handleClick = (event, row) => {
        props.history.push(`/routes/${row.id}`)
      };

      cell.align = header.align
      cell.clickable = header.clickable
      cell.type = header.type

      cells.push(cell)
    });

    return cells
  }

  function createHeaders() {
    return [
      {
        id: "id",
        clickable: true,
        align: "left",
        label: t("route.route-id"),
        type: "label"
      }
    ];
  }


  function renderTable() {
    const headers = createHeaders();
    const cells = createCells(headers);

    if (searchedData.length > 0) {
      return (
        <SimpleTable
          dataId={"id"}
          cells={cells}
          headers={headers}
          rows={searchedData}
        />
      );
    } else {
      return <PagePlaceholder image={getIcon("seo-consulting.svg")} text={t("route.no-routes-found")} />
    }
  }


  function generateRoutesModal() {
    return (
      <Dialog open={generateRoutesModalOpen}>
        <DialogTitle>
          {t("route.sync-routes-question")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("route.sync-routes-description")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setGenerateRoutesModalOpen(false)}

          >
            {t('common.cancel')}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleStartSync}
          >
            {t('hierarchy.start-sync')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <Box>
      <HeaderBlock
        title={t("route.routes")}
        right={
          <Grid container spacing={2} alignItems="center" justify="flex-end">
            <Grid item>
              {statusOutput != null ? <Chip label={t("common.last-sync-status", { status: statusOutput })} /> : null}
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => generatingRoutes ? handleStartSync() : setGenerateRoutesModalOpen(true)}
              >
                {generatingRoutes ? t("common.check-sync-status") : t("route.sync-routes")}
              </Button>
            </Grid>
            <Grid item>
              <Search
                searchTitle={t("route.search-routes")}
                data={originalData}
                searchField={"id"}
                returnSearchMatches={handleSearch}
              />
            </Grid>
          </Grid>
        }
      />

      {generateRoutesModal()}
      <PageContainer hasFooter>
        {loading ? <Loading /> : renderTable()}
      </PageContainer>
    </Box>
  )
}

export default ListRoutesPage
